import { useEffect } from 'react';
import { fetchReportsTypes } from '@/app/state/ui/reportsSlice';
import { useToolkitDispatch } from '@/app/hooks';
import { useReportsTypes } from '@/app/state/ui/reportsSlice/index.hooks';

export const useReportTypes = () => {
    const toolkitDispatch = useToolkitDispatch();

    useEffect(() => {
        toolkitDispatch(fetchReportsTypes());
    }, [toolkitDispatch]);

    return useReportsTypes();
};
